import { useContext, useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAlert from "components/SoftAlert";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import ValidationService from "services/ValidationService";
import { useNavigate, useParams } from "react-router-dom";
import Constants from "utils/Constants";

import _ from "lodash";
import StorageService from "services/StorageService";
import Datepicker from "components/CustomFields/Datepicker";
import { AppBar, Switch, Tab, Tabs } from "@mui/material";
import Document from "examples/Icons/Document";
import Settings from "examples/Icons/Settings";
import Basket from "examples/Icons/Basket";
import Office from "examples/Icons/Office";
import Swal from "sweetalert2";

function CompaniesModify() {
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [editCompanyStatus, setEditCompanyStatus] = useState(false);
  const [vatNumber, setVatNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [addressNo, setAddressNo] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [credits, setCredits] = useState("");
  const [friendlyName, setFriendlyName] = useState("");
  const [companyBusiness, setCompanyBusiness] = useState("");
  const [companyGemi, setCompanyGemi] = useState("");
  const [email, setEmail] = useState("");
  const [companyTaxOffice, setTaxOffice] = useState("");
  const [internetProviderName, setInternetProviderName] = useState("");
  const [internetProviderContractNumber, setInternetProviderContractNumber] = useState("");
  const [internetProviderContractDate, setInternetProviderContractDate] = useState("");
  const [isB2C, setIsB2C] = useState(false);
  const [isB2B, setIsB2B] = useState(false);
  const [activationStatus, setActivationStatus] = useState("DRAFT");
  const [contractStatus, setContractStatus] = useState(false);
  const [contractSigningUrl, setContractSigningUrl] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const accessLevel = StorageService.getAccessLevel();

  const handleCompanyNameChange = (e) => setCompanyName(e.target.value);
  const handleCityChange = (e) => setCity(e.target.value);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleAddressNoChange = (e) => setAddressNo(e.target.value);
  const handleZipChange = (e) => setZipCode(e.target.value);
  const handleFriendlyNameChange = (e) => setFriendlyName(e.target.value);
  const handleCompanyBusiness = (e) => setCompanyBusiness(e.target.value);
  const handleCompanyGemi = (e) => setCompanyGemi(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleCompanyTaxOffice = (e) => setTaxOffice(e.target.value);
  const handleInternetProviderNameChange = (e) => setInternetProviderName(e.target.value);
  const handleInternetProviderContractNumber = (e) =>
    setInternetProviderContractNumber(e.target.value);
  const handleInternetProviderContractDate = (newDate) =>
    setInternetProviderContractDate(newDate[0]);

  const handleIsB2BChange = (e) => setIsB2B(e.target.checked);
  const handleIsB2CChange = (e) => setIsB2C(e.target.checked);

  const modifyCompany = async (red = true) => {
    setShowAlert(false);
    setEditCompanyStatus(true);
    const company = {
      vatNumber: vatNumber,
      country: "GR",
      name: companyName,
      street: address,
      streetNumber: addressNo,
      postalCode: zipCode,
      city: city,
      gemi: companyGemi,
      friendlyName: friendlyName,
      business: companyBusiness,
      email: email,
      taxOffice: companyTaxOffice,
      documentIdNo: "",
      supplyAccountNo: "",
      countryDocumentId: "",
      internetProviderName: internetProviderName,
      internetProviderContractNumber: internetProviderContractNumber,
      internetProviderContractDate: internetProviderContractDate,
      isB2CTransactions: isB2C,
      isB2BTransactions: isB2B,
      isB2GTransactions: false,
    };

    const valErrors = ValidationService.validateCompany(company);

    if (valErrors) {
      setAlertText(valErrors.message);
      setShowAlert(true);
      setEditCompanyStatus(false);
      return;
    }

    const response = await ApiService.putData(`/api/v1/companies/${id}`, company);

    if (!response) {
      ToastUtils.error("Αδυναμία επεξεργασίας εταιρείας");
      setEditCompanyStatus(false);
      return;
    }

    if (red) {
      ToastUtils.success("Επιτυχής επεξεργασία εταιρείας");
      navigate("/companies/companies-list");
    }
  };

  const sendContract = async () => {
    await modifyCompany(false);
    const result = await ApiService.postData(`/api/v1/companies/${id}/send-document-sign`, {});
    if (result === null) {
      ToastUtils.error("Αδυναμία αποστολής σύμβασης.");
      return;
    }
    ToastUtils.success("Επιτυχής αποστολής σύμβασης.");
    navigate("/companies/companies-list");
  };

  const sendStatement = async () => {
    await modifyCompany(false);
    const result = await ApiService.postData(`/api/v1/companies/${id}/send-statement`, {});
    if (result === null) {
      ToastUtils.error("Αδυναμία αποστολής δήλωσης myDATA.");
      return;
    }
    ToastUtils.success("Επιτυχής αποστολής δήλωσης myData.");
    navigate("/companies/companies-list");
  };

  const fetchCompanyData = async () => {
    const response = await ApiService.getData(`/api/v1/companies/${id}`);
    if (!response) {
      ToastUtils.error("Αδυναμία εύρεσης στοιχείων εταιρείας!");
      return;
    }
    setVatNumber(response.data.vatNumber);
    setApiKey(response.data.apiKey);
    setCompanyName(response.data.name);
    setCity(response.data.city);
    setAddress(response.data.street);
    setAddressNo(response.data.streetNumber);
    setZipCode(response.data.postalCode);
    setCredits(response.data.credits);
    setFriendlyName(response.data.friendlyName);
    setCompanyBusiness(response.data.business);
    setCompanyGemi(response.data.gemi);
    setEmail(response.data.email);
    setTaxOffice(response.data.taxOffice);
    setInternetProviderName(response.data.internetProviderName);
    setInternetProviderContractNumber(response.data.internetProviderContractNumber);
    setInternetProviderContractDate(response.data.internetProviderContractDate);
    setIsB2C(response.data.isB2CTransactions);
    setIsB2B(response.data.isB2BTransactions);
    setActivationStatus(response.data.activationStatus);
    setContractStatus(_.get(response, "data.contract.contractStatus"));
    setContractSigningUrl(_.get(response, "data.contract.docusealSigningUrl", null));
  };

  useEffect(() => {
    fetchCompanyData();
  }, [id]);

  const handleContractClick = () => {
    window.open(contractSigningUrl);
  };

  const handleApiKeyClick = () => {
    navigator.clipboard.writeText(apiKey);
    Swal.fire({
      icon: "success",
      title: "Επιτυχία!",
      text: "Το κλειδί διαβίβασης αντιγράφηκε στο πρόχειρο!",
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={3} mb={4}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={9}>
            <Card sx={{ overflow: "visible" }}>
              <SoftBox p={2} lineHeight={1}>
                <SoftTypography variant="h6" fontWeight="medium">
                  Επεξεργασία Εταιρείας
                </SoftTypography>
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  Επεξεργαστείτε τα στοιχεία της εταιρείας σας.
                </SoftTypography>
                <Divider />
                {showAlert && (
                  <SoftAlert color="error" dismissible show={showAlert}>
                    {alertText}
                  </SoftAlert>
                )}
                <AppBar position="static">
                  <Tabs
                    orientation={"horizontal"}
                    value={1}
                    onChange={() => {}}
                    sx={{ backgroundColor: "transparent" }}
                  >
                    <Tab label={vatNumber} icon={<Office />} />
                    {contractSigningUrl !== null ? (
                      <Tab
                        label="Προβολή Σύμβασης"
                        icon={<Document />}
                        onClick={handleContractClick}
                      />
                    ) : (
                      <></>
                    )}
                    {apiKey !== null ? <Tab label={credits} icon={<Basket />} /> : <> </>}
                    {apiKey !== null ? (
                      <Tab
                        label="Κλειδί Διαβίβασης"
                        icon={<Settings />}
                        onClick={handleApiKeyClick}
                      />
                    ) : (
                      <> </>
                    )}
                  </Tabs>
                </AppBar>

                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Φιλική Ονομασία
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Φιλική Ονομασία"
                        size="large"
                        value={friendlyName}
                        onChange={handleFriendlyNameChange}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Email
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="email"
                        placeholder="Email"
                        size="large"
                        value={email}
                        onChange={handleEmailChange}
                      />
                    </SoftBox>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Επωνυμία
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Επωνυμία"
                        size="large"
                        value={companyName}
                        onChange={handleCompanyNameChange}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Δραστηριότητα
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Δραστηριότητα"
                        size="large"
                        value={companyBusiness}
                        onChange={handleCompanyBusiness}
                      />
                    </SoftBox>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          ΔΟΥ
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="ΔΟΥ"
                        size="large"
                        value={companyTaxOffice}
                        onChange={handleCompanyTaxOffice}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Αριθμός Γ.Ε.ΜΗ.
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Αριθμός Γ.Ε.ΜΗ."
                        size="large"
                        value={companyGemi}
                        onChange={handleCompanyGemi}
                      />
                    </SoftBox>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Διεύθυνση
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Διεύθυνση"
                        size="large"
                        value={address}
                        onChange={handleAddressChange}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Αριθμός Διεύθυνσης
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Αριθμός Διεύθυνσης"
                        size="large"
                        value={addressNo}
                        onChange={handleAddressNoChange}
                      />
                    </SoftBox>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Πόλη
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Πόλη"
                        size="large"
                        value={city}
                        onChange={handleCityChange}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Τ.Κ.
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Τ.Κ."
                        size="large"
                        value={zipCode}
                        onChange={handleZipChange}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        B2C
                      </SoftTypography>
                      <Switch
                        checked={isB2C}
                        onChange={handleIsB2CChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />{" "}
                    </SoftBox>
                    <SoftBox ml={0.5} mb={0.25}></SoftBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        B2B
                      </SoftTypography>
                      <Switch
                        checked={isB2B}
                        onChange={handleIsB2BChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </SoftBox>
                  </Grid>
                </Grid>
                <Divider />
                <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Πάροχος Διαδικτύου (Π.Δ.)
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Πάροχος Διαδικτίου"
                        size="large"
                        value={internetProviderName}
                        onChange={handleInternetProviderNameChange}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Αριθμός σύμβασης Π.Δ.
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput
                        type="text"
                        placeholder="Αριθμός σύμβασης Π.Δ."
                        size="large"
                        value={internetProviderContractNumber}
                        onChange={handleInternetProviderContractNumber}
                      />
                    </SoftBox>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <SoftBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                        <Datepicker
                          xs={12}
                          md={12}
                          title="Ημερομηνία σύμβασης Π.Δ."
                          handler={handleInternetProviderContractDate}
                          initialValue={internetProviderContractDate}
                        />
                      </SoftBox>
                    </SoftBox>
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item xs={6} md={6}>
                    <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                      <SoftButton
                        variant="gradient"
                        color="success"
                        style={{ width: "100%" }}
                        onClick={sendContract}
                        disabled={activationStatus !== "DRAFT"}
                      >
                        ΑΠΟΣΤΟΛΗ ΣΥΜΒΑΣΗΣ
                      </SoftButton>
                    </SoftBox>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                      <SoftButton
                        variant="gradient"
                        color="info"
                        style={{ width: "100%" }}
                        onClick={sendStatement}
                        disabled={contractStatus !== "SIGNED"}
                      >
                        ΑΠΟΣΤΟΛΗ ΔΗΛΩΣΗΣ MYDATA
                      </SoftButton>
                    </SoftBox>
                  </Grid>
                </Grid>
                <Divider />

                <SoftBox display="flex" justifyContent="flex-end" mt={3}>
                  <SoftButton
                    variant="gradient"
                    color="warning"
                    style={{ width: "100%" }}
                    onClick={modifyCompany}
                    disabled={editCompanyStatus}
                  >
                    ΕΠΕΞΕΡΓΑΣΙΑ ΕΤΑΙΡΕΙΑΣ
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CompaniesModify;
